import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import "react-daterange-picker/dist/css/react-calendar.css";
import Divider from "@mui/material/Divider";
import FormControl from "@mui/material/FormControl";
import spinner from "../../assign-prescriptions/images/spinner.gif";
import { Grid, Box, Button, Avatar, Typography } from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/lab";
import DateAdapter from "@mui/lab/AdapterDateFns";
import moment from "moment-timezone";
import { withTranslation } from "react-i18next";
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { frFR } from "@mui/material/locale";
import { enUS } from "@mui/material/locale";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import AppBar from "@mui/material/AppBar";
import SearchableMultiSelect from "../../common/SearchableMultiSelect";
import { getDefaultDateRange, getDateRangeByPreset, formatFromDateForAPI, formatToDateForAPI } from "../../../utils/datetime.utils";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

const localeTheme = createTheme(
  {},
  localStorage.getItem("i18nextLng") === "en" ? enUS : frFR
);
class EnhancedTableHead extends React.Component {
  render() {
    const { order, orderBy, sortId, t } = this.props;
    const rows = [
      {
        id: "first_name",
        numeric: false,
        disablePadding: false,
        label: t("Report.Transaction.FirstName"),
        padding: "10px",
        field: "first_name",
      },
      {
        id: "last_name",
        numeric: false,
        disablePadding: false,
        label: t("Report.Transaction.LastName"),
        padding: "10px",
        field: "last_name",
      },
      // {
      //   id: "stock_code",
      //   numeric: false,
      //   disablePadding: false,
      //   label: t("Report.Transaction.StockCode"),
      //   padding: "10px",
      //   field: "stock_code",
      // },
      // {
      //   id: "pucode",
      //   numeric: false,
      //   disablePadding: false,
      //   label: t("Report.Transaction.PUCode"),
      //   padding: "10px",
      //   field: "pucode",
      // },
      { id: "store_name", numeric: false, disablePadding: false, label: t("Report.phiLogs.Store"), padding: '10px', field: 'store_name' },
      { id: "location_name", numeric: false, disablePadding: false, label: t("Report.phiLogs.Location"), padding: '10px', field: 'location_name' },
      { id: "action_name", numeric: false, disablePadding: false, label: t("Report.auditTrail.action_title"), padding: '10px', field: 'action_name' },
      {
        id: "description",
        numeric: false,
        disablePadding: false,
        label: t("Location.Description"),
        padding: "10px",
        field: "description",
      },
      { id: "username", numeric: false, disablePadding: false, label: t("Report.inActive.UserName"), padding: '10px', field: 'username' },
      {
        id: "created_on",
        numeric: false,
        disablePadding: false,
        label: t("Report.phiLogs.CreatedOn"),
        padding: "10px",
        field: "created_on",
      },
    ];

    return (
      <TableHead>
        <TableRow>
          {rows.map((row) => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? "none" : "default"}
                sortDirection={orderBy === row.id ? order : false}
                style={{ padding: row.padding, color: "rgba(0, 0, 0, 0.54)" }}
              >
                {
                  <Tooltip
                    title={t("Global.Label.Filter.Sort")}
                    placement={row.numeric ? "bottom-end" : "bottom-start"}
                    enterDelay={300}
                  >
                    <TableSortLabel
                      active={orderBy === row.field && sortId === row.id}
                      direction={order}
                    >
                      {row.label}
                    </TableSortLabel>
                  </Tooltip>
                }
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  sortId: PropTypes.string.isRequired,
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

const styles = (theme) => ({
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: "auto",
  },
  dob: {
    paddingTop: "25px",
  },
  headerdiv: {
    paddingLeft: "15%",
    paddingTop: "10",
  },
  padding10px: {
    padding: "8px",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 390,
  },
  logoWrapper: {
    position: "absolute",
    width: "89%",
    height: "70%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "rgba(255,255,255,0.5)",
    zIndex: "7869",
  },
  spinner: {
    position: "absolute",
    background: "rgba(255,255,255,.4)",
    width: "100%",
    height: "100%",
    zIndex: "9999",
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: "calc(50% - 32.5px)",
    left: "calc(50% - 65px)",
    position: "absolute",
    width: "130px",
    userSelect: "none",
  },
  hidden: {
    display: "none",
  },
});

let TransactionFilterObj = {
  store_ids: [],
  box_ids: [],
  searchtext: "",
  fromdate: "",
  todate: "",
  pageNo: 0,
  pageSize: 10,
  sortOrder: "desc",
  sortColumn: "created_on",
  tableName: "",
  timezone: ""
};

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment()
  .tz(timeZone)
  .utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class AuditReportComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "desc",
      dob: "",
      orderBy: "created_on",
      page: 0,
      rowsPerPage: 10,
      searchtext: "",
      store_id: [],
      box_id: [],
      fromdate: null,
      todate: null,
      dateRangePreset: 'last7days',
      isOpen: false,
      stores: [],
      boxes: [],
      boxvalues: [],
      accountValues: [],
      nstores: [],
      nboxes: [],
      chipstores: [],
      chipboxes: [],
      loader: false,
      isDataEmpty: true,
      totalRecords: 0,
      selectedObject: {},
      isButtonDisabled: false,
      locale: localStorage.getItem("i18nextLng") === "en" ? enLocale : frLocale,
    };
    this.debouceTimeout = null;
  }

  componentDidMount() {
    // Get user's timezone for date filtering
    let userTimeZone = sessionStorage.getItem('timeZone');
    if (['null', null, 'undefined', undefined, ''].includes(userTimeZone)) {
      userTimeZone = defaultZone;
    }
    TransactionFilterObj.timezone = userTimeZone.substring(userTimeZone.lastIndexOf(' ') + 1);
    
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + "accounts", {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(accounts => {
        const { t } = this.props
        let All = [{ id: "-1", name: t("Global.Label.DropDown.All") }]
        const storelist = accounts.map(account => {
          return { id: account.id, name: account.name };
        });
        const accountValues = All.concat(storelist);
        this.setState({ accountValues, parent_account_id: accountValues[0].id });
        this.BindBoxesbyStoreId(storelist.map(x => x.id));
      });
    // Set default date range (T-30 days to today)
    const defaultDates = getDefaultDateRange();
    this.setState({ 
      fromdate: defaultDates.fromDate,
      todate: defaultDates.toDate,
      dateRangePreset: 'last7days'
    });

    TransactionFilterObj = {
      store_ids: [],
      box_ids: [],
      searchtext: "",
      fromdate: formatFromDateForAPI(defaultDates.fromDate),
      todate: formatToDateForAPI(defaultDates.toDate),
      pageNo: 0,
      pageSize: 10,
      sortOrder: "desc",
      sortColumn: "created_on",
      tableName: "",
      timezone: TransactionFilterObj.timezone // Preserve timezone
    };
    this.BindGrid();
  }

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem("i18nextLng");
    let zone;
    zone = sessionStorage.getItem("timeZone");
    const date = moment(new Date(requestDate));
    if (["null", null, "undefined", undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === "en"
      ? date
        .tz(zone.substring(zone.lastIndexOf(" ") + 1))
        .format("MM/DD/YYYY hh:mm:ss A")
      : date
        .tz(zone.substring(zone.lastIndexOf(" ") + 1))
        .format("DD/MM/YYYY hh:mm:ss A");
  };

  extractAudioDeviceInfo = (description) => {
    if (!description) return null;
    
    try {
      // Look for audio device information in the description
      const audioDeviceMatch = description.match(/\[AUDIO_DEVICE_INFO:(.+?)\]/);
      if (!audioDeviceMatch) return null;
      
      const deviceInfoJson = audioDeviceMatch[1];
      return JSON.parse(deviceInfoJson);
    } catch (error) {
      console.warn('Failed to extract audio device information:', error);
      return null;
    }
  };

  extractCameraDeviceInfo = (description) => {
    if (!description) return null;
    
    try {
      // Look for camera device information in the description
      const cameraDeviceMatch = description.match(/\[CAMERA_DEVICE_INFO:(.+?)\](?=\s*\[|$)/);
      if (!cameraDeviceMatch) return null;
      
      const deviceInfoJson = cameraDeviceMatch[1];
      return JSON.parse(deviceInfoJson);
    } catch (error) {
      console.warn('Failed to extract camera device information:', error);
      return null;
    }
  };

  getCleanDescription = (description) => {
    if (!description) return description;
    
    // Remove all tags from description for clean display
    return description
      .replace(/\[AUDIO_DEVICE_INFO:\{[\s\S]*?\}\](?=\s*\[|$)/g, '')
      .replace(/\[CAMERA_DEVICE_INFO:\{[\s\S]*?\}\](?=\s*\[|$)/g, '')
      .replace(/\[EVENT:[^\]]*\]/g, '')
      .replace(/\[SOURCE:[^\]]*\]/g, '')
      .replace(/\[SEVERITY:[^\]]*\]/g, '')
      .replace(/\[METADATA:[^\]]*\]/g, '')
      .replace(/\[PUCODE:[^\]]*\]/g, '')
      .replace(/\[ACTOR:[^\]]*\]/g, '')
      .replace(/\[VERSION:[^\]]*\]/g, '')
      .replace(/\[BROWSER:[^\]]*\]/g, '')
      .replace(/\[LOGIN_METHOD:[^\]]*\]/g, '')
      .replace(/\[BROWSER_DETAILS:\{[\s\S]*?\}\](?=\s*\[|$)/g, '')
      .replace(/\[BROWSER_CHANGES:\{[\s\S]*?\}\](?=\s*\[|$)/g, '')
      .trim();
  };

  formatAudioDeviceInfo = (audioDeviceInfo) => {
    if (!audioDeviceInfo) return null;
    
    try {
      const { ringingDevice, callingDevice, micInput } = audioDeviceInfo;
      
      // Helper to render device info (handles both old and new format)
      const renderDeviceInfo = (device, label) => {
        if (!device) return null;
        
        // New format with preferred/selected
        if (device.selected || device.preferred) {
          return (
            <div style={{ marginBottom: "10px" }}>
              <strong>{label}:</strong>
              <div style={{ marginLeft: "10px", fontSize: "13px" }}>
                {device.preferred && (
                  <div>
                    <span style={{ color: '#666' }}>Preferred: </span>
                    <span style={{ color: '#1976d2' }}>{device.preferred.deviceName || 'Unknown'}</span>
                  </div>
                )}
                <div>
                  <span style={{ color: '#666' }}>Selected: </span>
                  <span style={{ color: '#333', fontWeight: 'bold' }}>{(device.selected && device.selected.deviceName) || 'Default System Device'}</span>
                </div>
              </div>
            </div>
          );
        }
        
        // Old format (backward compatibility)
        return (
          <div style={{ marginBottom: "10px" }}>
            <strong>{label}:</strong><br />
            <span style={{ color: device.selectionType === 'default' ? '#666' : '#333' }}>
              {device.deviceName || 'Unknown'}
            </span>
          </div>
        );
      };
      
      return (
        <div style={{ marginTop: "15px", padding: "10px", backgroundColor: "#f5f5f5", borderRadius: "5px" }}>
          <h4 style={{ margin: "0 0 10px 0", color: "#333" }}>Audio Devices Information</h4>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "10px" }}>
            {renderDeviceInfo(ringingDevice, "Ringing Device")}
            {renderDeviceInfo(callingDevice, "Calling Device")}
            {renderDeviceInfo(micInput, "Microphone")}
          </div>
        </div>
      );
    } catch (error) {
      console.warn('Failed to parse audio device information:', error);
      return null;
    }
  };

  formatCameraDeviceInfo = (cameraDeviceInfo) => {
    if (!cameraDeviceInfo) return null;
    
    try {
      // Handle both old format (selectedCamera) and new format (preferred/selected)
      const { available, count, selectedCamera, preferred, selected, devices, error } = cameraDeviceInfo;
      
      // Determine which camera to highlight (new format uses 'selected', old format uses 'selectedCamera')
      const activeSelected = selected || selectedCamera;
      
      return (
        <div style={{ marginTop: "15px", padding: "10px", backgroundColor: "#f0f7ff", borderRadius: "5px" }}>
          <h4 style={{ margin: "0 0 10px 0", color: "#333" }}>Camera Information</h4>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
            <div>
              <strong>Camera Available:</strong><br />
              <span style={{ color: available ? '#2e7d32' : '#c62828' }}>
                {available ? 'Yes' : 'No'}
              </span>
            </div>
            <div>
              <strong>Camera Count:</strong><br />
              <span>{count || 0}</span>
            </div>
            
            {/* New format: show preferred and selected separately */}
            {(preferred || selected) && (
              <div style={{ gridColumn: "1 / -1" }}>
                {preferred && (
                  <div style={{ marginBottom: "5px" }}>
                    <strong>Preferred Camera:</strong><br />
                    <span style={{ color: '#1976d2' }}>
                      {preferred.deviceName || 'Unknown'}
                    </span>
                  </div>
                )}
                {selected && (
                  <div>
                    <strong>Selected Camera:</strong><br />
                    <span style={{ color: '#333', fontWeight: 'bold' }}>
                      {selected.deviceName || 'Unknown'}
                    </span>
                  </div>
                )}
              </div>
            )}
            
            {/* Old format: show selectedCamera for backward compatibility */}
            {!selected && !preferred && selectedCamera && (
              <div style={{ gridColumn: "1 / -1" }}>
                <strong>Selected Camera:</strong><br />
                <span style={{ color: '#333' }}>
                  {selectedCamera.deviceName || 'Unknown'}
                </span>
              </div>
            )}
            
            {devices && devices.length > 0 && (
              <div style={{ gridColumn: "1 / -1" }}>
                <strong>Available Cameras:</strong><br />
                <ul style={{ margin: "5px 0", paddingLeft: "20px" }}>
                  {devices.map((device, index) => {
                    const isPreferred = preferred && preferred.deviceId === device.deviceId;
                    const isSelected = activeSelected && activeSelected.deviceId === device.deviceId;
                    
                    return (
                      <li key={index} style={{ 
                        color: isSelected ? '#333' : (isPreferred ? '#1976d2' : '#666'),
                        fontWeight: isSelected ? 'bold' : 'normal'
                      }}>
                        {device.deviceName}
                        {isSelected && ' (Selected)'}
                        {isPreferred && !isSelected && ' (Preferred)'}
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
            {error && (
              <div style={{ gridColumn: "1 / -1", color: '#c62828' }}>
                <strong>Error:</strong> {error}
              </div>
            )}
          </div>
        </div>
      );
    } catch (error) {
      console.warn('Failed to parse camera device information:', error);
      return null;
    }
  };

  parseAuditMetadata = (description = "") => {
    if (!description) {
      return null;
    }

    try {
      const eventMatch = description.match(/\[EVENT:([A-Z0-9_]+)\]/i);
      const sourceMatch = description.match(/\[SOURCE:([A-Z0-9_]+)\]/i);
      const severityMatch = description.match(/\[SEVERITY:([A-Z0-9_]+)\]/i);
      const pucodeMatch = description.match(/\[PUCODE:([A-Z0-9_]+)\]/i);
      const actorMatch = description.match(/\[ACTOR:([A-Z0-9_]+)\]/i);
      const versionMatch = description.match(/\[VERSION:([^\]]+)\]/i);
      const browserMatch = description.match(/\[BROWSER:([^\]]+)\]/i);
      const loginMethodMatch = description.match(/\[LOGIN_METHOD:([^\]]+)\]/i);
      const browserDetailsMatch = description.match(/\[BROWSER_DETAILS:(\{[\s\S]*?\})\](?=\s*\[|$)/);
      const browserChangesMatch = description.match(/\[BROWSER_CHANGES:(\{[\s\S]*?\})\](?=\s*\[|$)/);
      const metadataMatch = description.match(/\[METADATA:(\{[\s\S]*\})\]/);

      let metadata = null;
      let browserDetails = null;
      let browserChanges = null;

      if (metadataMatch) {
        try { metadata = JSON.parse(metadataMatch[1]); } catch (_e) { /* ignore */ }
      }
      if (browserDetailsMatch) {
        try { browserDetails = JSON.parse(browserDetailsMatch[1]); } catch (_e) { /* ignore */ }
      }
      if (browserChangesMatch) {
        try { browserChanges = JSON.parse(browserChangesMatch[1]); } catch (_e) { /* ignore */ }
      }

      return {
        eventType: eventMatch ? eventMatch[1] : null,
        source: sourceMatch ? sourceMatch[1] : null,
        severity: severityMatch ? severityMatch[1] : null,
        pucode: pucodeMatch ? pucodeMatch[1] : null,
        actor: actorMatch ? actorMatch[1] : null,
        version: versionMatch ? versionMatch[1] : null,
        browser: browserMatch ? browserMatch[1] : null,
        loginMethod: loginMethodMatch ? loginMethodMatch[1] : null,
        browserDetails,
        browserChanges,
        metadata,
      };
    } catch (error) {
      console.warn("Failed to parse audit metadata", error);
      return null;
    }
  };

  getConsultDetails = (auditRow) => {
    if (!auditRow || !auditRow.description) {
      return null;
    }

    const parsed = this.parseAuditMetadata(auditRow.description);
    if (!parsed || parsed.eventType !== "PHARMACIST_EXPECTED_FOR_CONSULT" || !parsed.metadata) {
      return null;
    }

    const metadata = parsed.metadata || {};
    const recipients = Array.isArray(metadata.recipients) ? metadata.recipients : [];

    const onlineList =
      Array.isArray(metadata.onlineRecipients) && metadata.onlineRecipients.length > 0
        ? metadata.onlineRecipients
        : recipients.filter((r) => r.online).map((r) => r.username);

    const offlineList =
      Array.isArray(metadata.offlineRecipients) && metadata.offlineRecipients.length > 0
        ? metadata.offlineRecipients
        : recipients.filter((r) => !r.online).map((r) => r.username);

    const totalRecipients =
      typeof metadata.totalRecipients === "number" ? metadata.totalRecipients : recipients.length;
    const totalOnline =
      typeof metadata.totalOnline === "number" ? metadata.totalOnline : onlineList.length;
    const totalOffline =
      typeof metadata.totalOffline === "number" ? metadata.totalOffline : offlineList.length;

    return {
      pickupCode: metadata.pickupCode || "N/A",
      kioskName: metadata.kioskName || "",
      accountId: metadata.accountId || "",
      recipients,
      totalRecipients,
      totalOnline,
      totalOffline,
      onlineList,
      offlineList,
    };
  };

  renderStatusPill = (label, background, color) => (
    <span
      style={{
        display: "inline-block",
        padding: "2px 10px",
        borderRadius: "999px",
        fontSize: "12px",
        fontWeight: 600,
        backgroundColor: background,
        color,
      }}
    >
      {label}
    </span>
  );

  renderConsultDetails = (consultDetails) => {
    const { recipients, totalRecipients, totalOnline, totalOffline } = consultDetails;

    return (
      <Box sx={{ mt: 3 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
          Consult Attempt
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            mt: 0.5,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: "#1b5e20",
              fontWeight: 600,
              backgroundColor: "#e8f5e9",
              padding: "4px 10px",
              borderRadius: "999px",
              display: "inline-block",
            }}
          >
            Pickup {consultDetails.pickupCode}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#0d47a1",
              fontWeight: 600,
              backgroundColor: "#e3f2fd",
              padding: "4px 10px",
              borderRadius: "999px",
              display: "inline-block",
            }}
          >
            {consultDetails.kioskName || "Unknown kiosk"}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 2,
            mt: 2,
          }}
        >
          <Box
            sx={{
              backgroundColor: "#e3f2fd",
              color: "#0d47a1",
              padding: "8px 16px",
              borderRadius: "12px",
              fontWeight: 600,
            }}
          >
            Expected: {totalRecipients}
          </Box>
          <Box
            sx={{
              backgroundColor: "#e8f5e9",
              color: "#1b5e20",
              padding: "8px 16px",
              borderRadius: "12px",
              fontWeight: 600,
            }}
          >
            Online: {totalOnline}
          </Box>
          <Box
            sx={{
              backgroundColor: "#fff3e0",
              color: "#e65100",
              padding: "8px 16px",
              borderRadius: "12px",
              fontWeight: 600,
            }}
          >
            Offline: {totalOffline}
          </Box>
        </Box>

        {totalRecipients === 0 ? (
          <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
            No pharmacists are currently associated with this store. Verify store assignments
            or consult toggles for the team.
          </Typography>
        ) : (
          <Table size="small" sx={{ mt: 2 }}>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Username</TableCell>
                <TableCell>Account</TableCell>
                <TableCell>Status</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>Last Active</TableCell>
                <TableCell>Consult Toggle</TableCell>
                <TableCell>Can Receive Call</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {recipients.map((recipient) => {
                const isOnline = Boolean(recipient.online);
                const isConsultEnabled = Boolean(recipient.persistedConsultEnabled);
                const hasToken = Boolean(recipient.hasPortalToken || recipient.hasMobileToken);
                const canNotify = isConsultEnabled && hasToken && isOnline;
                
                // Format last activity timestamp
                // Use lastLoginLogoutOn if available (includes presence_updated_at or last_login_on)
                // Fallback to lastLoginOn for backward compatibility
                const timestampToFormat = recipient.lastLoginLogoutOn || recipient.lastLoginOn;
                let lastActivityDisplay = "Never";
                
                if (timestampToFormat) {
                  try {
                    lastActivityDisplay = this.convertToTimeZone(timestampToFormat);
                  } catch (err) {
                    console.error('Error formatting last activity:', err);
                    // Try to display raw value if formatting fails
                    lastActivityDisplay = timestampToFormat instanceof Date 
                      ? timestampToFormat.toISOString() 
                      : String(timestampToFormat);
                  }
                }

                return (
                  <TableRow key={recipient.userId || recipient.username}>
                    <TableCell>{recipient.name || "—"}</TableCell>
                    <TableCell>{recipient.username || "—"}</TableCell>
                    <TableCell>{recipient.accountName || "—"}</TableCell>
                    <TableCell>
                      {this.renderStatusPill(
                        isOnline ? "Online" : "Offline",
                        isOnline ? "#e8f5e9" : "#fdecea",
                        isOnline ? "#1b5e20" : "#c62828"
                      )}
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: "13px",
                        }}
                      >
                        {lastActivityDisplay}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      {this.renderStatusPill(
                        isConsultEnabled ? "Enabled" : "Disabled",
                        isConsultEnabled ? "#e8f5e9" : "#eceff1",
                        isConsultEnabled ? "#1b5e20" : "#546e7a"
                      )}
                    </TableCell>
                    <TableCell>
                      {this.renderStatusPill(
                        canNotify ? "Yes" : "No",
                        canNotify ? "#e3f2fd" : "#fff3e0",
                        canNotify ? "#0d47a1" : "#e65100"
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        )}
      </Box>
    );
  };

  renderAuditMetadataDetails = (auditRow) => {
    const description = auditRow ? auditRow.description : undefined;
    const parsed = this.parseAuditMetadata(description);
    if (!parsed || (!parsed.eventType && !parsed.pucode && !parsed.actor && !parsed.version && !parsed.browser && !parsed.loginMethod && !parsed.browserDetails && !parsed.browserChanges && !(parsed.metadata && (parsed.metadata.orderId != null || parsed.metadata.binId != null)))) {
      return null;
    }

    const meta = parsed.metadata || {};

    return (
      <Box sx={{ mt: 3 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
          Audit Tags
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
          {parsed.eventType && this.renderStatusPill(`Event: ${parsed.eventType}`, "#e3f2fd", "#0d47a1")}
          {parsed.pucode && this.renderStatusPill(`PUCODE: ${parsed.pucode}`, "#f3e5f5", "#7b1fa2")}
          {parsed.actor && this.renderStatusPill(`Actor: ${parsed.actor}`, "#e0f2f1", "#00695c")}
          {parsed.source && this.renderStatusPill(`Source: ${parsed.source}`, "#e8eaf6", "#283593")}
          {parsed.severity && this.renderStatusPill(`Severity: ${parsed.severity}`, "#fff3e0", "#e65100")}
          {parsed.version && this.renderStatusPill(`Version: ${parsed.version}`, "#e8f5e9", "#2e7d32")}
          {parsed.browser && this.renderStatusPill(`Browser: ${parsed.browser}`, "#fce4ec", "#c2185b")}
          {parsed.loginMethod && this.renderStatusPill(`Login: ${parsed.loginMethod}`, parsed.loginMethod === 'SSO' ? "#fff8e1" : "#e1f5fe", parsed.loginMethod === 'SSO' ? "#ff8f00" : "#0277bd")}
          {parsed.browserDetails && this.renderStatusPill(`Browser Details: Available`, "#f3e5f5", "#7b1fa2")}
          {parsed.browserChanges && this.renderStatusPill(`Browser Changes: Detected`, "#ffebee", "#c62828")}
          {meta.orderId != null && meta.orderId !== "" && this.renderStatusPill(`Order ID: ${meta.orderId}`, "#eceff1", "#455a64")}
          {meta.binId != null && meta.binId !== "" && this.renderStatusPill(`Bin: ${meta.binId}`, "#e8f5e9", "#2e7d32")}
        </Box>
      </Box>
    );
  };

  renderDescriptionSummary = (row) => {
    if (!row || !row.description) {
      return "";
    }

    const parsed = this.parseAuditMetadata(row.description);
    if (parsed && parsed.eventType === "PHARMACIST_EXPECTED_FOR_CONSULT" && parsed.metadata) {
      const metadata = parsed.metadata;
      const recipients = Array.isArray(metadata.recipients) ? metadata.recipients : [];
      const total =
        typeof metadata.totalRecipients === "number" ? metadata.totalRecipients : recipients.length;
      const online =
        typeof metadata.totalOnline === "number"
          ? metadata.totalOnline
          : recipients.filter((r) => r.online).length;

      return `Consult attempt: ${total} pharmacist${total === 1 ? "" : "s"} expected (${online} online)`;
    }

    const clean = this.getCleanDescription(row.description);
    if (parsed && parsed.eventType) {
      return `${parsed.eventType.replace(/_/g, " ")}${clean ? ` · ${clean}` : ""}`;
    }

    return clean;
  };
  handleChangePage = (event, page) => {
    event && event.preventDefault();
    const { data } = this.state;
    TransactionFilterObj.pageNo = page;
    if (data && data.length > 0) {
      this.BindGrid();
    }
  };

  handleChangeRowsPerPage = (event) => {
    const { data } = this.state;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.pageSize = event.target.value;
    if (data && data.length > 0) {
      this.BindGrid();
    }
  };

  //Search Text Box change event
  onSearchChange = (event) => {
    this.debouceTimeout && clearInterval(this.debouceTimeout);
    const searchString = event.target.value;
    this.setState({ searchtext: searchString && searchString });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.searchtext = searchString;
    this.debouceTimeout = setTimeout(() => {
      this.BindGrid();
    }, 1000);
  };

  onFromDateSelect = (date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({ fromdate: dateObj, dateRangePreset: '' });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateObj);
    this.BindGrid();
  };

  onToDateSelect = (date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({ todate: dateObj, dateRangePreset: '' });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.todate = formatToDateForAPI(dateObj);
    this.setState({ loader: true });
    this.BindGrid();
  };

  handleBlurfrom = (value, date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({
      fromdate: dateObj,
      dateRangePreset: ''
    });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateObj);
    this.BindGrid();
  };

  handleBlurtodate = (value, date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({
      todate: dateObj,
      dateRangePreset: ''
    });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.todate = formatToDateForAPI(dateObj);
    this.BindGrid();
  };

  handleDateRangePresetChange = (event) => {
    const preset = event.target.value;
    if (!preset) return;
    
    const dateRange = getDateRangeByPreset(preset);
    this.setState({
      fromdate: dateRange.fromDate,
      todate: dateRange.toDate,
      dateRangePreset: preset
    });
    
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateRange.fromDate);
    TransactionFilterObj.todate = formatToDateForAPI(dateRange.toDate);
    this.BindGrid();
  };

  BindGrid = () => {
    this.setState({ loader: true, data: null });
    fetch(process.env.REACT_APP_BASEURL + "audit_report", {
      method: "post",
      withCredentials: true,
      headers: {
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(TransactionFilterObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((uData) => {
        if (uData && uData.results && uData.results.length > 0) {
          this.setState({
            data: uData.results,
            totalRecords: uData && uData.total,
          });
          setTimeout(() => {
            this.setState({
              loader: uData && uData.total && false,
              isDataEmpty: false,
              isButtonDisabled: false,
            });
          }, 5000);
        } else {
          this.setState({
            data: null,
            loader: false,
            isDataEmpty: true,
            isButtonDisabled: true,
          });
        }
      });
  };

  handleDescriptionClick = (event, data) => {
    event.preventDefault();
    this.setState({ detailDialogOpen: true, selectedObject: data });
  };

  handleDescriptionClose = (event) => {
    event.preventDefault();
    this.setState({ detailDialogOpen: false, selectedObject: {} });
  };

  BindBoxesbyStoreId(store_ids) {
    if (store_ids.length > 0) {
      let BoxesObj = {
        store_ids: store_ids
      }
      fetch(process.env.REACT_APP_BASEURL + 'getBoxesByStoreIds', {
        method: 'post',
        withCredentials: true,
        headers: {
          'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(BoxesObj)
      })
        .then(response => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        })
        .then(data => {
          const { t } = this.props;
          let All = [{ id: "-1", name: t("Global.Label.DropDown.All") }]
          const boxlist = data.map(account => {
            return { id: account.id, name: account.name };
          });
          const boxvalues = All.concat(boxlist);
          //const boxvalues = boxlist;
          this.setState({ chipboxes: [], nboxes: [], boxvalues: boxvalues });
        });
    }

  }

  handleStoreChange = event => {
    const storeid = event.target.value;
    const storeids = [];
    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = storeid.findIndex(x => x.id === '-1');
    
    // If "All" is selected (regardless of other selections), show only "All" chip
    if (AllprocessedIndex > -1) {
      // Only show "All" chip
      chipprocessed = [this.state.accountValues[0]]; // "All" is always first item
      // But include all stores in processed for filtering
      for (let i = 0; i < this.state.accountValues.length; i++) {
        processed.push(this.state.accountValues[i]);
      }
    }
    else if (storeid.length === 0) {
      // Nothing selected
      chipprocessed = [];
      processed = [];
    }
    else if (storeid.length > 0) {
      // Individual items selected (no "All")
      for (let i = 0; i < event.target.value.length; i++) {
        const element = event.target.value[i];
        if (element.id !== '-1') {
          chipprocessed.push(element);
          processed.push(element);
        }
      }
    }
    
    this.setState({ chipstores: chipprocessed });
    this.setState({ nstores: processed });

    if (processed.length > 0) {
      for (let i = 0; i < processed.length; i++) {
        if (processed[i].id !== '-1') {
          storeids.push(processed[i].id)
        }
      }
    }
    this.setState({ store_id: storeids });
    this.BindBoxesbyStoreId(storeids);
    TransactionFilterObj.store_ids = storeids;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    this.BindGrid();
  };

  handleBoxChange = event => {
    const boxid = event.target.value;
    const boxids = [];

    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = boxid.findIndex(x => x.id === '-1');
    
    // If "All" is selected (regardless of other selections), show only "All" chip
    if (AllprocessedIndex > -1) {
      // Only show "All" chip
      chipprocessed = [this.state.boxvalues[0]]; // "All" is always first item
      // But include all boxes in processed for filtering
      for (let i = 0; i < this.state.boxvalues.length; i++) {
        processed.push(this.state.boxvalues[i]);
      }
    }
    else if (boxid.length === 0) {
      // Nothing selected
      chipprocessed = [];
      processed = [];
    }
    else if (boxid.length > 0) {
      // Individual items selected (no "All")
      for (let i = 0; i < event.target.value.length; i++) {
        const element = event.target.value[i];
        if (element.id !== '-1') {
          chipprocessed.push(element);
          processed.push(element);
        }
      }
    }
    
    this.setState({ chipboxes: chipprocessed });
    this.setState({ nboxes: processed });

    if (processed.length > 0) {
      for (let i = 0; i < processed.length; i++) {
        if (processed[i].id !== '-1') {
          boxids.push(processed[i].id)
        }
      }
    }
    this.setState({ box_id: boxids });
    TransactionFilterObj.box_ids = boxids;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    this.BindGrid();
  };

  // Handle deletion of individual store chip
  handleDeleteStoreChip = (chipToDelete) => (event) => {
    event.stopPropagation();
    
    // If deleting "All" chip, clear everything
    if (chipToDelete.id === '-1') {
      this.setState({ 
        chipstores: [],
        nstores: [],
        store_id: []
      });
      
      TransactionFilterObj.store_ids = [];
      TransactionFilterObj.pageNo = 0;
      TransactionFilterObj.sortOrder = 'desc';
      TransactionFilterObj.sortColumn = 'created_on';
      TransactionFilterObj.tableName = '';
      this.BindBoxesbyStoreId([]);
      this.BindGrid();
      return;
    }
    
    // Otherwise, remove individual chip
    const updatedStores = this.state.chipstores.filter(chip => chip.id !== chipToDelete.id);
    const updatedNStores = this.state.nstores.filter(store => store.id !== chipToDelete.id);
    
    this.setState({ 
      chipstores: updatedStores,
      nstores: updatedNStores,
      store_id: updatedNStores.filter(s => s.id !== '-1').map(s => s.id)
    });
    
    const storeids = updatedNStores.filter(s => s.id !== '-1').map(s => s.id);
    this.BindBoxesbyStoreId(storeids);
    TransactionFilterObj.store_ids = storeids;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    this.BindGrid();
  };

  // Handle deletion of individual box chip
  handleDeleteBoxChip = (chipToDelete) => (event) => {
    event.stopPropagation();
    
    // If deleting "All" chip, clear everything
    if (chipToDelete.id === '-1') {
      this.setState({ 
        chipboxes: [],
        nboxes: [],
        box_id: []
      });
      
      TransactionFilterObj.box_ids = [];
      TransactionFilterObj.pageNo = 0;
      TransactionFilterObj.sortOrder = 'desc';
      TransactionFilterObj.sortColumn = 'created_on';
      TransactionFilterObj.tableName = '';
      this.BindGrid();
      return;
    }
    
    // Otherwise, remove individual chip
    const updatedBoxes = this.state.chipboxes.filter(chip => chip.id !== chipToDelete.id);
    const updatedNBoxes = this.state.nboxes.filter(box => box.id !== chipToDelete.id);
    
    this.setState({ 
      chipboxes: updatedBoxes,
      nboxes: updatedNBoxes,
      box_id: updatedNBoxes.filter(b => b.id !== '-1').map(b => b.id)
    });
    
    const boxids = updatedNBoxes.filter(b => b.id !== '-1').map(b => b.id);
    TransactionFilterObj.box_ids = boxids;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    this.BindGrid();
  };

  // Clear all store selections
  handleClearAllStores = (event) => {
    event.stopPropagation();
    this.setState({ 
      chipstores: [],
      nstores: [],
      store_id: []
    });
    
    TransactionFilterObj.store_ids = [];
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    this.BindBoxesbyStoreId([]);
    this.BindGrid();
  };

  // Clear all box selections
  handleClearAllBoxes = (event) => {
    event.stopPropagation();
    this.setState({ 
      chipboxes: [],
      nboxes: [],
      box_id: []
    });
    
    TransactionFilterObj.box_ids = [];
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    this.BindGrid();
  };

  render() {
    const { classes, t } = this.props;
    const { data, totalRecords, locale } = this.state;
    const selectedAudit = this.state.selectedObject || {};
    const consultDetails = this.getConsultDetails(selectedAudit);
    const hasUsername = Boolean(selectedAudit && selectedAudit.username);
    const hasEmail = Boolean(selectedAudit && selectedAudit.email);
    const hasPhone = Boolean(selectedAudit && selectedAudit.phone);
    const dialogTitle = consultDetails
      ? "Consult Attempt Details"
      : t("Users.UserDetails.UserDetailsTitle");
    
    return (
      <div>
        {this.state.loader ? (
          <div className={classes.spinner}>
            <img className={classes.spinnerImage} src={spinner} alt="loading" />
          </div>
        ) : null}
        <div id="react-no-print">
          <Dialog
            open={this.state.detailDialogOpen || false}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
              style: { borderRadius: "5px", maxWidth: "50%" },
            }}
          >
            <AppBar
              position="static"
              color="default"
              sx={{
                backgroundColor: "#00a7e1",
                color: "white",
                padding: "4px",
                fontWeight: "bold",
              }}
            >
              {dialogTitle}
            </AppBar>
            <DialogContent>
              <div>
                {this.state.selectedObject.picture_url && this.state.selectedObject.picture_url !== "" && (
                  <Avatar
                    style={{ borderRadius: "2%", width: "150px", height: "150px", margin: "auto" }}
                    alt=""
                    src={this.state.selectedObject.picture_url}
                  />
                )}
                {hasUsername && (
                  <p>
                    <span style={{ fontWeight: "bolder" }}>
                      {t("Users.UserName")} :
                    </span>
                    {selectedAudit.username}
                  </p>
                )}
                {hasEmail && (
                  <p>
                    <span style={{ fontWeight: "bolder" }}>
                      {t("Users.Email")} :
                    </span>
                    {selectedAudit.email}
                  </p>
                )}
                {hasPhone && (
                  <p>
                    <span style={{ fontWeight: "bolder" }}>
                      {t("Users.Phone")} :
                    </span>
                    {selectedAudit.phone}
                  </p>
                )}
                {(((this.state.selectedObject && ![null, undefined, ''].includes(this.state.selectedObject.created_on))) && <p>
                  <span style={{ fontWeight: "bolder" }}>
                    {t("Users.DateTime")} :
                  </span>
                { this.convertToTimeZone(this.state.selectedObject.created_on) }
                </p>)}
              </div>

              {this.renderAuditMetadataDetails(this.state.selectedObject)}

              {consultDetails && this.renderConsultDetails(consultDetails)}
              
              {/* Display audio device information for consultation events */}
              {this.state.selectedObject && this.state.selectedObject.description && 
                this.state.selectedObject.action_name && 
                this.state.selectedObject.action_name.toLowerCase().includes('consultation') && 
                this.formatAudioDeviceInfo(this.extractAudioDeviceInfo(this.state.selectedObject.description))
              }
              
              {/* Display camera device information for consultation events */}
              {this.state.selectedObject && this.state.selectedObject.description && 
                this.state.selectedObject.action_name && 
                this.state.selectedObject.action_name.toLowerCase().includes('consultation') && 
                this.formatCameraDeviceInfo(this.extractCameraDeviceInfo(this.state.selectedObject.description))
              }
              
              { (![null, undefined].includes(this.state.selectedObject.is_update) && (Boolean(this.state.selectedObject.is_update) === true)) ? 
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <h3>{t("Users.UserDetails.Information")}</h3>
                </div>
                : ''}


            </DialogContent>
            <DialogActions>
              <Button
                onClick={(e) => {
                  this.handleDescriptionClose(e);
                }}
                color="primary"
                className={classes.primaryButton}
              >
                {t("Report.Picked.Temperature.CloseButton")}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <Box component="div">
          <Grid
            container spacing={4} sx={{ mt: 0, ml: 0, width: '100%', p: '0% 2% 1%' }}
          >
            <Grid item xs={3} md={3} style={{ paddingLeft: 0 }}>
              <SearchableMultiSelect
                label={t("Report.Assign.Store")}
                items={this.state.accountValues || []}
                selectedChips={this.state.chipstores}
                selectedItems={this.state.nstores}
                onChange={this.handleStoreChange}
                onDeleteChip={this.handleDeleteStoreChip}
                onClearAll={this.handleClearAllStores}
                placeholder="Search stores..."
                id="select-multiple-chip-store"
              />
            </Grid>
            <Grid item xs={3} md={3}>
              <SearchableMultiSelect
                label={t("Report.Assign.Box")}
                items={this.state.boxvalues || []}
                selectedChips={this.state.chipboxes}
                selectedItems={this.state.nboxes}
                onChange={this.handleBoxChange}
                onDeleteChip={this.handleDeleteBoxChip}
                onClearAll={this.handleClearAllBoxes}
                placeholder="Search locations..."
                id="select-multiple-chip"
              />
            </Grid>
            <Grid item xs={2} md={2}>
              <FormControl sx={{ width: "100%" }}>
                <InputLabel variant="standard">{t("Global.Label.DropDown.DateRange") || "Date Range"}</InputLabel>
                <Select
                  value={this.state.dateRangePreset}
                  onChange={this.handleDateRangePresetChange}
                  variant="standard"
                  label={t("Global.Label.DropDown.DateRange") || "Date Range"}
                >
                  <MenuItem value="today">{t("Global.Label.DropDown.Today") || "Today"}</MenuItem>
                  <MenuItem value="last7days">{t("Global.Label.DropDown.Last7Days") || "Last 7 days"}</MenuItem>
                  <MenuItem value="last15days">{t("Global.Label.DropDown.Last15Days") || "Last 15 days"}</MenuItem>
                  <MenuItem value="last30days">{t("Global.Label.DropDown.Last30Days") || "Last 30 days"}</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={2} md={2}>
              <FormControl sx={{ width: "100%" }}>
                <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                  <DesktopDatePicker
                    disableFuture
                    keyboard
                    value={this.state.fromdate}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t("Report.Transaction.FromDate")}
                        variant="standard"
                        allowKeyboardControl={true}
                        onBlur={this.handleBlurfrom}
                      />
                    )}
                    onChange={this.onFromDateSelect}
                  />
                </LocalizationProvider>
              </FormControl>
            </Grid>
            <Grid item xs={2} md={2}>
              <FormControl sx={{ width: "100%" }}>
                <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                  <DesktopDatePicker
                    disableFuture
                    keyboard
                    value={this.state.todate}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t("Report.Transaction.ToDate")}
                        variant="standard"
                        allowKeyboardControl={true}
                        onBlur={this.handleBlurtodate}
                      />
                    )}
                    onChange={this.onToDateSelect}
                  />
                </LocalizationProvider>
              </FormControl>
            </Grid>
            <Grid item xs={3} md={3} style={{ paddingLeft: 0 }}>
              <FormControl fullWidth>
                <TextField
                  id="idsearchtxt"
                  defaultValue=""
                  value={this.state.searchtxt}
                  label={t("Report.Transaction.Search")}
                  onChange={this.onSearchChange}
                  variant="standard"
                />
              </FormControl>
            </Grid>
          </Grid>
        </Box>
        <Divider style={{ marginTop: "10px", height: "5px" }} />
        <div className={classes.tableWrapper}>
          <Table className={classes.table} aria-labelledby="tableTitle">
            <EnhancedTableHead
              order={TransactionFilterObj.sortOrder}
              orderBy={TransactionFilterObj.sortColumn}
              sortId={this.state.sortId}
            />
            <TableBody>
              {!data ? (
                <TableRow>
                  <TableCell
                    colSpan={17}
                    style={{ textAlign: "center", padding: "10px 0px" }}
                  >
                    {this.state.isDataEmpty &&
                      t("Report.Transaction.NoDataFound")}
                  </TableCell>
                </TableRow>
              ) : (
                data.length &&
                data.length > 0 &&
                data.map((n, index) => {
                  const parsedMeta = this.parseAuditMetadata(n && n.description);
                  const eventType = parsedMeta && parsedMeta.eventType;
                  const isConsultExpectation = eventType === "PHARMACIST_EXPECTED_FOR_CONSULT";
                  const summaryText = isConsultExpectation
                    ? this.renderDescriptionSummary(n)
                    : this.getCleanDescription(n && n.description);
                  const needsFallbackName =
                    isConsultExpectation &&
                    (!n || ((!n.first_name || n.first_name.trim() === "") &&
                      (!n.last_name || n.last_name.trim() === "")));
                  const fallbackFirst =
                    (parsedMeta && parsedMeta.metadata && parsedMeta.metadata.actorFirstName) ||
                    "Consult";
                  const fallbackLast =
                    (parsedMeta && parsedMeta.metadata && parsedMeta.metadata.actorLastName) ||
                    "Audit";
                  const fallbackUsername =
                    (parsedMeta && parsedMeta.metadata && parsedMeta.metadata.actorUsername) ||
                    "consult-audit";

                  const displayFirstName =
                    (n && n.first_name && n.first_name.trim()) ||
                    (needsFallbackName ? fallbackFirst : "");
                  const displayLastName =
                    (n && n.last_name && n.last_name.trim()) ||
                    (needsFallbackName ? fallbackLast : "");
                  const displayUsername =
                    (n && n.username && n.username.trim()) ||
                    (needsFallbackName ? fallbackUsername : "");
                  return (
                    <TableRow key={n.id || `${n.username}-${n.created_on}-${index}`}>
                      <TableCell className={classes.padding10px}>
                        {displayFirstName}
                      </TableCell>
                      <TableCell className={classes.padding10px}>
                        {displayLastName}
                      </TableCell>
                      {/* <TableCell className={classes.padding10px}>
                        {n.stock_code}
                      </TableCell>
                      <TableCell className={classes.padding10px}>
                        {n.pucode}
                      </TableCell> */}
                      <TableCell className={classes.padding10px}>
                        {n.store_name}
                      </TableCell>
                      <TableCell className={classes.padding10px}>
                        {n.location_name}
                      </TableCell>
                      <TableCell className={classes.padding10px}>
                        {n.action_name}
                      </TableCell>
                      <TableCell
                        className={classes.padding10px}
                        style={{
                          color: "blue",
                          fontWeight: 500,
                          textDecoration: "none ",
                          fontSize: "1rem",
                          cursor: "pointer"
                        }}
                        onClick={(event) => this.handleDescriptionClick(event, n)}
                      >
                        {summaryText}
                      </TableCell>
                      <TableCell className={classes.padding10px}>
                        {displayUsername}
                      </TableCell>
                      <TableCell className={classes.padding10px}>
                        {n.created_on
                          ? this.convertToTimeZone(n && n.created_on)
                          : ""}
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </div>
        <ThemeProvider theme={localeTheme}>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={totalRecords || 0}
            rowsPerPage={TransactionFilterObj.pageSize}
            page={TransactionFilterObj.pageNo}
            backIconButtonProps={{
              "aria-label": "Previous Page",
            }}
            nextIconButtonProps={{
              "aria-label": "Next Page",
            }}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
          />
        </ThemeProvider>
      </div>
    );
  }
}

AuditReportComponent.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withTranslation()(AuditReportComponent));




// WEBPACK FOOTER //
// ./src/components/reports/audit-report/index.js